import Rock from './Rock'
import Outdoor from './Outdoor'
import Sand from './Sand'
import Palm from './Palm'

export default function Island(props) {

    return <>
        {/* Sand island */}
        <Sand nodes={props.nodes} />
        
        {/* Palm trees */}
        <Palm nodes={props.nodes} />
        
        {/* Outdoor elements */}
        <Rock nodes={props.nodes} />
        <Outdoor nodes={props.nodes} />
    </>

}